<div class="main-layout">
<app-header
  [showExitButton]="true"
  [showSupportRequestButton]="true"
  (feedbackButtonClick)="showFeedbackDialog()"
/>

<main class="main-layout-wrapper">
  <router-outlet></router-outlet>
</main>

  <footer class="app-footer">
    <div class="wrapper">
      <div class="app-footer__content">
       <p>
         &copy; 2026 АО «РТКомм.РУ»
       </p>
      </div>
    </div>
  </footer>
</div>
